export default class ProtectImg {
    constructor() {
        this.init();
    }

    init() {
        this.run();
    }

    //todo:vendorに追加して個々のJSから呼び出さない用に変更
    run() {
        function imageGuard(selector) {
            var guard_selector = document.querySelectorAll(selector);

            var guard_style = {
                'pointer-events': 'none',
                '-webkit-touch-callout': 'none',
                '-moz-touch-callout': 'none',
                'touch-callout': 'none',
                '-webkit-user-select': 'none',
                '-moz-user-select': 'none',
                'user-select': 'none',
            };

            Object.keys(guard_style).forEach(function (v, i, a) {
                for (var n = 0; n < guard_selector.length; n++) {
                    guard_selector[n].style[v] = guard_style[v];
                }
            });
        }

        document.addEventListener('DOMContentLoaded', function () {
            imageGuard('img');
        });

        document.addEventListener(
            'contextmenu',
            function (e) {
                e.preventDefault();
            },
            false
        );
    }
}
